import { render } from "./RechnungDashboard.vue?vue&type=template&id=5df1bfd8&scoped=true&ts=true"
import script from "./RechnungDashboard.vue?vue&type=script&lang=ts"
export * from "./RechnungDashboard.vue?vue&type=script&lang=ts"

import "./RechnungDashboard.vue?vue&type=style&index=0&id=5df1bfd8&scoped=true&language=scss&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df1bfd8"]])

export default __exports__